'use client'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import React from 'react'
import styles from './styles.module.scss'

const ViewAll = ({ navigationTheme = 'light' }) => {
  const t = useTranslations('translation')

  return (
    <div className={`${styles.container} ${styles[navigationTheme]}`}>
      <Image
        width={21}
        height={21}
        src="/img/games-slider/view-all-icon.svg"
        className={styles.viewAllIcon}
        alt="view all"
      />
      <div className={styles.text}>{t('viewAll')}</div>
    </div>
  )
}
export default React.memo(ViewAll)
